import {
  createRouter,
  useLocation,
  LocationChange,
  RouteSectionProps,
  Location,
  RouteDefinition,
} from '@solidjs/router';
import { JSX } from 'solid-js';

export function StaticRouter(props: {
  children: RouteDefinition[];
  state: any;
  url: string;
  root: (props: RouteSectionProps) => JSX.Element;
}) {
  function getLocation() {
    return {
      value: props.url,
      state: props.state,
    };
  }
  const location = createMemo<LocationChange>(getLocation, getLocation(), {
    equals(pre, next) {
      return !(pre.value !== next.value || pre.state !== next.state);
    },
  });

  const Router = createRouter({
    get: location,
    set() {},
    create(router) {
      const nav = router.navigatorFactory();
      createEffect<LocationChange>((pre) => {
        const loc = location();
        if (pre) {
          nav(loc.value || '/', {
            state: loc.state,
            replace: true,
            resolve: true,
          });
        }
        return loc;
      });
    },
  });

  const rootLocation = useLocation();
  const context = getRouterContext();

  function Root(pps: RouteSectionProps) {
    // 复制顶级的nav
    const subContext = getRouterContext();
    subContext.navigatorFactory = context.navigatorFactory;
    const location = useLocation();

    const isCurrentRoute = createMemo(() => location.pathname === rootLocation.pathname);
    createComputed((pre) => {
      return isCurrentRoute() ? rootLocation.search : pre;
    }, rootLocation.search);

    return <props.root {...pps} />;
  }

  return <Router base="/" root={Root} children={props.children} />;
}

function getRouterContext(): any {
  const { context } = getOwner()!;
  const routerSymbol = Object.getOwnPropertySymbols(context).findLast((it) => context[it].navigatorFactory)!;
  return context[routerSymbol];
}

export function snapeLocation(location: Location): LocationItem {
  return {
    url: location.pathname + location.search,
    pathname: location.pathname,
    state: getState(),
  };
}

export interface LocationItem {
  pathname: string;
  url: string;
  state: any;
}

export type Action = 'PUSH' | 'POP' | 'REPLACE';

function getState() {
  if (import.meta.env.SSR || !history.state) {
    return { _depth: 0 };
  }
  return history.state;
}
function getDepth() {
  return getState()._depth || 0;
}
let depth = getDepth() - 1;
export function getAction() {
  const newDepth = getDepth();
  const action: Action = depth > newDepth ? 'POP' : depth === newDepth ? 'REPLACE' : 'PUSH';
  depth = newDepth;
  return action;
}
